<div class="row text-center">
    <div class="col">        
        <img class="logo" src="assets/images/PPL-logo-3.png" alt="">
    </div>
</div>
<div class="row text-center">
    <div class="col">
        <h1 class="heading-text">
            {{maintenaceModeText}}
        </h1>
    </div>
</div>
